import { FunctionComponent, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import TextInput from 'components/GlobalStyles/Inputs/TextInput'
import MagnifyingGlass from 'components/SVG/MagnifyingGlass'
import Spacer from 'components/Spacer'

import NoResultsModal, { INoResultsModalProps } from './NoResultsModal'

const SearchByAddressContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-basis: 100%;
  @media (min-width: ${props => props.theme.metrics.desktopMedium}px) {
    flex-basis: 500px;
  }
`

interface IDisabledProp {
  disabled: boolean
}
const StyledButton = styled.button<IDisabledProp>`
  width: 58px;
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors[props.disabled ? 'grey3' : 'blue4']};
  padding-top: 2px; /* font correction */
  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
`

const InputContainer = styled.div`
  height: 40px;
  /* flex-grow: 1; */
  width: 100%;
`

const SearchFormContainer = styled.form`
  display: flex;
  width: 100%;

  @media (min-width: ${props => props.theme.metrics.desktopMedium}px) {
    max-width: 500px;
  }
`

interface IProps {
  address: string
  onChange: (name: string, value: string) => void
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void
}

const SearchInput: FunctionComponent<IProps & INoResultsModalProps> = ({
  address,
  onChange,
  onSubmit,
  ...noResultsModalProps
}) => {
  const theme = useContext(ThemeContext)

  return (
    <>
      <SearchByAddressContainer>
        <SearchFormContainer onSubmit={onSubmit}>
          <InputContainer>
            <TextInput
              name="searchBar"
              onChangeImmediate={onChange}
              onChange={onChange}
              delay={0}
              clearOnClick={!!address}
              placeholder="Enter City, Neighbhorhood, or Zip Code"
              borderRadius={`${theme.radii[4]}px`}
              value={address}
              fullHeight
              controlled
            />
          </InputContainer>
          <Spacer size={theme.spacings[8]} />
          <StyledButton
            type="submit"
            disabled={!address}
          >
            <MagnifyingGlass
              fill={theme.colors.white}
              height={18}
              width={18}
            />
          </StyledButton>
        </SearchFormContainer>
      </SearchByAddressContainer>
      <NoResultsModal {...noResultsModalProps} />
    </>
  )
}

export default SearchInput
